module.exports = __webpack_public_path__ + "img/horizontal_3_1_9016.0fd429bb.png";